import React, { useEffect, useState } from 'react';
import { isDesktop, isMobile } from 'react-device-detect';
import { Loader } from 'uikit/loader/Loader';
import { Box } from '@primer/components';
import logoImage from 'components/sideNav/assets/logo.png';
import DownloadAppDesktopPreview from 'components/DownloadAppDesktopPreview/DownloadAppDesktopPreview';
import './EventUrlWithRedirectionSupport.scss';
import { EVENT_REDIRECTION_URL, EVENT_URL } from 'utils/constants';
import { getPlayStoreOrAppStoreUrl } from 'utils/common';

const EventUrlWithRedirectionSupport = () => {
    const urlDetails = window.location.href.split('url=');
    const redirectedUrl =
        urlDetails.length === 2
            ? urlDetails[1]
            : urlDetails[0].replace(EVENT_REDIRECTION_URL, '');
    const [isShowDownloadAppSection, setIsShowDownloadAppSection] =
        useState(false);
    const url = window.location.href;

    const redirectToStore = () => {
        const { playStoreOrAppStoreUrl } = getPlayStoreOrAppStoreUrl();
        window.location.href = playStoreOrAppStoreUrl;
    };

    useEffect(() => {
        if (isMobile) {
            redirectToStore();
        } else {
            setIsShowDownloadAppSection(true);
        }
    }, []);

    const hanldeContinueOnWeb = () => {
        window.location.href = redirectedUrl;
    };

    return (
        <Box id="event-url-with-redirection">
            {!isShowDownloadAppSection ? (
                <Loader />
            ) : (
                <Box>
                    {isDesktop && (
                        <Box className="event-url-logo">
                            <img src={logoImage} alt="Covision" />
                        </Box>
                    )}
                    <Box className="download-app-page">
                        <Box display="flex" width="100%" flexWrap="wrap">
                            <Box
                                flex="1"
                                display="flex"
                                justifyContent="center"
                            >
                                {isDesktop ? (
                                    <DownloadAppDesktopPreview
                                        qrCodeUrl={url}
                                        hasRedirectUrl={urlDetails.length === 2}
                                        onContinue={hanldeContinueOnWeb}
                                    />
                                ) : (
                                    <Loader />
                                )}
                            </Box>
                        </Box>
                    </Box>
                </Box>
            )}
        </Box>
    );
};

export default EventUrlWithRedirectionSupport;
